module.exports = __webpack_public_path__ + "img/15.6346e26c.jpg";